module.exports = __webpack_public_path__ + "images/emoji/wheelchair.ad42394ee55361591182.png";